/**
 * ThemeToggle Atom Component
 * Toggles between dark and light themes, persists preference in localStorage
 */

import React, { useState, useEffect } from 'react';

export interface ThemeToggleProps {
  className?: string;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ className = '' }) => {
  const [isDark, setIsDark] = useState(() => {
    return document.documentElement.classList.contains('dark');
  });

  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [isDark]);

  return (
    <button
      type="button"
      onClick={() => setIsDark(!isDark)}
      className={`relative w-11 h-6 rounded-full bg-theme-toggle transition-colors duration-300 ${className}`}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {/* Sliding circle with star */}
      <span
        className={`absolute top-0 w-6 h-6 rounded-full bg-white dark:bg-black flex items-center justify-center text-primary transition-transform duration-300 ${isDark ? 'translate-x-5' : 'translate-x-0'}`}
      >
        {isDark ? (
          <svg width="16" height="16" viewBox="-1 -1.5 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.8113 0L8.36888 5.01808L13.6227 4.94874L9.33151 7.98075L11.021 12.956L6.8113 9.81179L2.60165 12.956L4.2911 7.98075L-5.81741e-05 4.94874L5.25373 5.01808L6.8113 0Z" />
          </svg>
        ) : (
          <svg width="16" height="16" viewBox="-0.5 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.13926 0L8.27591 4.00844L11.5516 1.43365L10.115 5.34465L14.2785 5.18699L10.8175 7.50669L14.2785 9.82638L10.115 9.66873L11.5516 13.5797L8.27591 11.0049L7.13926 15.0134L6.00261 11.0049L2.72694 13.5797L4.16347 9.66873L-2.81334e-05 9.82638L3.46098 7.50669L-2.81334e-05 5.18699L4.16347 5.34465L2.72694 1.43365L6.00261 4.00844L7.13926 0Z" />
          </svg>
        )}
      </span>
    </button>
  );
};

export default ThemeToggle;
